<template>
    <v-dialog
        v-model="addVacationDialog"
        persistent
        width="500"
    >
        <template v-slot:activator="{ attrs }">
            <v-btn
                v-if="modelType==='Add'"
                class="ma-1 action-btn text-subtitle-2"
                depressed
                color="primary"
                v-bind="attrs"
                @click="openDialog"
            >
                <v-icon
                    left
                    class="action-icon"
                >
                    mdi-plus
                </v-icon>
                Add Vacation
            </v-btn>
            <v-icon
                v-if="modelType==='Edit'"
                class="cp"
                v-bind="attrs"
                @click="openDialog"
            >
                mdi-pencil
            </v-icon>
        </template>
        <v-card id="add_vacation_dialog">            
            <v-card-title class="text-h5 lighten-2">
                <span v-if="modelType === 'Add'">Add Vacation</span>
                <span v-if="modelType === 'Edit'">Edit Vacation</span>
            </v-card-title>
            <v-divider />            
            <v-card-text>
                <v-form
                    ref="form"                    
                >
                    <v-row class="mt-5">
                        <v-col
                            cols="12"
                            sm="6"
                            md="4"
                        >                            
                            <v-menu
                                v-model="mStartDate"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="start_date"
                                        label="Start Date"
                                        persistent-hint
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="start_date"
                                    no-title
                                    @input="mStartDate = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="6"
                            md="4"
                        >  
                            <v-dialog
                                ref="startTimeDialog"
                                v-model="startTimeDialog"
                                :return-value.sync="start_time"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="start_time"
                                        label="Start Time"
                                        prepend-icon="mdi-clock-time-four-outline"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    />
                                </template>
                                <v-time-picker
                                    v-if="startTimeDialog"
                                    v-model="start_time"
                                    full-width
                                >
                                    <v-spacer />
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="startTimeDialog = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.startTimeDialog.save(start_time)"
                                    >
                                        OK
                                    </v-btn>
                                </v-time-picker>
                            </v-dialog>
                        </v-col>
                    </v-row>
                    <v-row class="mt-5">
                        <v-col
                            cols="12"
                            sm="6"
                            md="4"
                        >                            
                            <v-menu
                                v-model="mEndDate"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="end_date"
                                        label="End Date"
                                        persistent-hint
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    />
                                </template>
                                <v-date-picker
                                    v-model="end_date"
                                    no-title
                                    @input="mEndDate = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="6"
                            md="4"
                        >
                            <v-dialog
                                ref="endTimeDialog"
                                v-model="endTimeDialog"
                                :return-value.sync="end_time"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="end_time"
                                        label="End Time"
                                        prepend-icon="mdi-clock-time-four-outline"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    />
                                </template>
                                <v-time-picker
                                    v-if="endTimeDialog"
                                    v-model="end_time"
                                    full-width
                                >
                                    <v-spacer />
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="endTimeDialog = false"
                                    >
                                        Cancel
                                    </v-btn>
                                    <v-btn
                                        text
                                        color="primary"
                                        @click="$refs.endTimeDialog.save(end_time)"
                                    >
                                        OK
                                    </v-btn>
                                </v-time-picker>
                            </v-dialog>                 
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider />
            <v-card-actions>                
                <v-spacer />
                <v-btn
                    style="text-transform: none !important;"
                    outlined
                    light
                    @click="closedDialog"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    @click="save"
                >
                    <span v-if="modelType==='Add'">Add</span>
                    <span v-if="modelType==='Edit'">Update</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import dayjs from 'dayjs';
export default {
    name: 'AddVacation',    
    props: {
        modelType: {
            type: String,
            default: 'Add'
                       
        },
        startDate: {
            type: Date || Object,
            required: false,
            default: () => dayjs().toDate(), 
        },       
        endDate: {
            type: Date,
            required: false,
            default: () => dayjs().toDate(),
        },      
        vacation: {
            type: String,
            default: ''
        }  
    },
    data: () => ({
        addVacationDialog: false,
        start_date: null,
        start_time: null,
        end_date: null,
        end_time: null,
        mStartDate: false,
        mEndDate: false,
        startTimeDialog: false,
        endTimeDialog: false,        
    }),
    computed: {        
        formValid() {
            return this.center_id && this.memberCode;
        },
        getMemberCodeCenter() {
            return this.$store.getters.getMemberCodeCenter;
        },
        vacationStartDate() {
            return this.from;
        },
        enableAddVacation() {
            return this.vacations.length < 5;   
        }        
    },
    created() {
        this.start_date = this.startDate ? dayjs(this.startDate).format('YYYY-MM-DD'): dayjs().format('YYYY-MM-DD');
        this.start_time = this.startDate ? dayjs(this.startDate).format('hh:mm'): dayjs().format('hh:mm');
        this.end_date = this.endDate ? dayjs(this.endDate).format('YYYY-MM-DD'): dayjs().format('YYYY-MM-DD');
        this.end_time = this.endDate ? dayjs(this.endDate).format('hh:mm'): dayjs().format('hh:mm');   
    },
    methods: {
        openDialog() {
            this.addVacationDialog = true;
            if (this.modelType === 'Edit') {
                this.startDateTime = new Date(this.startDate);
                this.endDateTime = new Date(this.endDate);                
            }
        },
        closedDialog() {
            this.addVacationDialog = false;
        },
        save() {
            this.$emit('save-vacation', {
                mode: this.modelType,
                vacationNumber: this.vacation,
                start_date: this.start_date,
                start_time: this.start_time,
                end_date: this.end_date,
                end_time: this.end_time
            });
            this.closedDialog();
        },       
    }
};
</script>

<style>

</style>